import React from 'react';
import { Avatar, Box, ButtonBase, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { TaskProductBase } from '@domain/tasks/models/Task';
import { APP_CONFIG } from '../../../../../config/app.config';
import { Icon, IconSize } from '@shared/icons';

interface ProductCardProps {
  product: TaskProductBase;
  selected?: boolean;
  checked?: boolean;
  onSelect?: (productId: string) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({
  product,
  selected,
  checked,
  onSelect,
}) => {
  const colors = APP_CONFIG.ui.theme.colors;

  return (
    <ButtonBase
      onClick={() => onSelect?.(product.productId)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onSelect?.(product.productId);
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 2,
        p: 1,
        borderRadius: 2,
        border: `1px solid ${selected ? colors.primary : colors.border}`,
        bgcolor: selected ? alpha(colors.primary, 0.05) : colors.background,
        maxWidth: 300,
      }}
    >
      <Avatar
        variant="rounded"
        sx={{ width: 48, height: 48, border: 1, borderColor: APP_CONFIG.ui.theme.colors.border }}
        src={product.image}
        alt={product.title}
      />
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          height: 48,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography
          align='left'
          variant="caption"
          color={selected ? colors.primaryText : colors.secondaryText}
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            wordBreak: 'break-word',
          }}
        >
          {product.title || 'Product'}
        </Typography>
      </Box>
      {checked && (
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: '100px',
            bgcolor: colors.backgroundTint,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 1,
            flexShrink: 0,
          }}
        >
          <Icon icon="Check" size={IconSize.MEDIUM} color={colors.primary} />
        </Box>
      )}
    </ButtonBase>
  );
};

export default ProductCard;
